/* eslint eqeqeq: 0 */
import { List } from "immutable";
import * as constants from "../../constants/teaserList";
import { TeaserListItem } from "../../records/teaser_list";

export default function (state = new List(), action) {
  if (action.type == constants.ON_LOAD_TEASER_LIST_SUCCESS) {
    return new List(action.teaserList.objects).map(
      teaser => new TeaserListItem(teaser)
    );
  }
  if (action.type == constants.SET_TEASER_CHECKED) {
    const index = state.findIndex(teaser => teaser.id == action.id);
    return state.update(index, item => item.set("checked", action.checked));
  }
  if (action.type == constants.SET_TEASER_CHECKED_ALL) {
    return state.map(item => item.set("checked", action.checked));
  }

  return state;
}
